import * as yup from 'yup'
import { DedicatedLanesBid } from '../../../../types/apiTypes'

const RATE_TYPE: Exclude<DedicatedLanesBid['rateType'], undefined>[] = [
  'rfp_lane_carrier_line_haul_flat',
  'rfp_lane_carrier_line_haul_rpm',
  'rfp_lane_carrier_all_in',
]

export const DedicatedLanesBidFormSchema = yup.object({
  // Handles an edge case where MC# is null
  mcNumber: yup.number().nullable().notOneOf([undefined], 'Please select a Carrier'),
  dotNumber: yup.number().required('Please select a carrier.'),
  rateAmount: yup.number().required('Please enter a rate.').typeError('Please enter a rate.'),
  rateType: yup.mixed().oneOf(RATE_TYPE).required('Please select a rate type.'),
  weeklyLoadVolume: yup.string().required('Please enter an amount'),
  contactEmail: yup
    .string()
    .email('Please enter a valid email.')
    .required('Please enter your email.'),
  canDoWeekends: yup.boolean(),
  contactMessage: yup.string(),
  estimatedStartDate: yup
    .string()
    .required('Please enter estimated start date')
    .typeError('Please enter estimated start date'),
  truckCount: yup.string().required('Please enter truck count.'),
  driverCount: yup.string().required('Please enter driver count.'),
  trailerCount: yup.string().required('Please enter trailer count.'),
  contactPhone: yup
    .string()
    .required('Please enter your phone number.')
    .min(10, 'Phone number is not valid'),
})

export type TDedicatedLanesBidFormSchema = yup.InferType<typeof DedicatedLanesBidFormSchema>
